"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "importData", {
    enumerable: true,
    get: function() {
        return importData;
    }
});
const _helpers = require("@fedsim/helpers");
const importData = ({ payload, type, callback = _helpers.NOOP })=>{
    return {
        type,
        payload,
        callback
    };
};
